module.exports = __webpack_public_path__ + "static/media/molluschi.f8ab8256.svg";